// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'","fontStyle":"normal"},"className":"__className_06d0dd"};